import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router";
import {
  Box,
  Button,
  Checkbox,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  ListItem,
  ListItemText,
  makeStyles,
  Paper,
  SvgIcon,
  TextField,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Helmet } from "react-helmet";
import _ from "underscore";
import UtilService from "../../../../../helper/service";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjects } from "../../../../../store/actions/creator/creatorDashboard";
import { getExperiences, getListExperiencesReels, getProjectExperiences, setLoading } from "../../../../../store/actions";
import { initLiveAnalysisData } from "../../../../../store/actions/creator/creatorExperienceManager";
import { getNorm2, onGetClipInfo } from "../../../../../store/actions/creator/analysis";
import CompareHeader from "./header";
import CompareTable from "./table";
import CompareBar from "./compareBar";
import { PAGINATION_PER_PAGE_ITEM } from "../../../../../config/mock";
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import { Search as SearchIcon } from "react-feather";
import Projects from "../../dashboard/projects";
import clsx from "clsx";
import CreatorTable from "../../dashboard/table";
import CreatorTray from "../../dashboard/tray";
import CreatorResult from "../../dashboard/result";
import { addCompareData, updateCompareData, updateTableSort, getCompareTabData } from "../../../../../store/actions/creator/compare";
import roles from "../../../../../helper/roles";
import AnalyzeMobileSection from '../../../../atoms/creator/analyzeMobileSection';
import {
  getCreatorList,
  getCreatorsList,
  searchExperience,
  updatePage,
  updatesearchfilters,
  updateSearchKey,
  updateSearchText,
  updateSearchUsers
} from '../../../../../store/actions/experience/experience';
import { BackDropAnalyzeLoading, Loading } from "../../../../atoms/commonLoadings";

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import useWindowSize from '../../../../../helper/hooks/useWindowSize';

const useStyles = makeStyles((theme) => ({
  root: {
    flex: '1 1 auto',
    height: '100%',
    overflowX: 'hidden',
    background: '#F0F0F0',
    paddingTop: "37px"
  },
  container: {
    padding: 48,
    paddingTop: 98,
    paddingBottom: 0,
    overflow: 'auto',
    '@media (max-width: 1025px)': {
      padding: 12,
      paddingTop: 65
    },
  },
  bottomContainer: {
    marginLeft: 48,
    marginTop: 31,
    marginBottom: 48,
    paddingTop: 8,
    paddingBottom: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  dlgRoot: {
    background: '#F0F0F0'
  },
  dlgContent: {
    marginTop: 25,
    marginBottom: 25,
    overflow: 'hidden'
  },
  dlgTitle: {
    color: '#212D40',
    fontFamily: 'roboto-bold',
    fontSize: 35,
    '@media (max-width: 1025px)': {
      fontSize: 28,
    },
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 21,
    marginBottom: 17,
  },
  icon: {
    marginRight: -10,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  text: {
    color: '#697683'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  addBtn: {
    height: 37,
    borderRadius: 6,
    background: '#0179EE',
    color: 'white',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0d77d4',
    },
  },
  tableContainer: {
    overflowY: 'auto',
  },
  table: {
    marginLeft: 210,
    paddingTop: 20,
    overflowY: 'auto',
    height: 'calc(100vh - 210px)',
    '@media (max-width: 1025px)': {
      marginLeft: 0,
    },
  },
  title: {
    fontFamily: 'roboto-light',
    color: '#606B76',
    fontSize: 20,
    '& span': {
      color: '#017AEF'
    }
  },
  empty: {
    marginLeft: 200,
    marginRight: 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '85vh'
  },
  hover: {
    cursor: 'pointer'
  },
  headerPanel: {
    minHeight: 48,
    paddingTop: 3,
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #D9D9D9',
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    zIndex: 1
  },
  loadMoreDiv: {
    textAlign: 'center',
    marginBottom: 5
  },
  selected: {
    paddingBottom: 290
  },
  loadMoreBtn: {
    padding: '6px 20px',
    background: '#017AEF',
    marginTop: 0,
    marginBottom: 25,
    color: '#fff',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    textTransform: 'none',
  },
  modalBtn: {
    width: 80,
    height: 36,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
  }
}));

export default function Compare(props: any) {
  document.title = "Compare";
  const classes = useStyles();

  const [currentSessionId, setCurrentSessionId] = useState(localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "");
  const [sessionCode, setSessionCode] = useState(props.match.params.session_code);

  const [sortDirection, setSortDirection] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [isUserDropdown, setUserDropdown] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [Creators, setCreators] = useState<any>([]);
  const [selectedCompare, setSelectedCompare] = useState<any>([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [checked, setchecked] = useState<any>([]);

  const [selected, setSelected] = useState<any>([]);
  const { sessions, searchKey, searchUsers, searchfilters, creatorList, is_loading, listLoading, totalExperience, page, totalReelExperience } = useSelector((state: any) => state.experience);
  const { analyzeClipData, cliped } = useSelector((state: any) => state.analysis);
  const { specialProjectId } = useSelector((state: any) => state.creatorExperienceManager);
  const { compareData, path } = useSelector((state: any) => state.compare);
  const [compareProcessing, setCompareProcessing] = useState(false);

  const [experienceList, setExperienceList] = useState<any>([]);
  const [fromList, setFromList] = useState(false);
  const [dlgOpen, setDlgOpen] = useState(false);

  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const dispatch = useDispatch();
  const [filterDirection, setFilterDirection] = useState(true);
  const [currentFilterArray, setcurrentFilterArray] = useState<any>({ compareFilter: "immersion", filterDirection: true });
  const [curCategory, setCurCategory] = useState('immersion');
  const [filter, setFilter] = useState('');
  const [projectId, setProjectId] = useState(-1);
  const [compareMode, setCompareMode] = useState<any>(1);
  const [immersionNorm, setImmersionNorm] = useState<any>(0);
  const [safetyNorm, setSafetyNorm] = useState(0);
  const [compareTabData, setCompareTabData] = useState(null);

  const [tagLoading, setTagLoading] = useState<boolean>(false);

  const theme = useTheme();
  const { width } = useWindowSize();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'));
  const session_code = props.match.params.session_code;
  const ids = experienceList.map((x: any) => {
    if (x.clip_id) {
      return {
        clip_id: x.clip_id.replace('clip-', ''),
        session_code: x.session_code,
        from_clip: x.start + '',
        to_clip: x.end + '',
      }
    } else {
      return {
        session_code: x.session_code
      }
    }
  }).filter((x: any) => x.session_code !== 'industry_norm');

  useEffect(() => {
    setSessionCode(session_code);
    if (session_code)
      localStorage.setItem('session_code', session_code);
  }, [session_code]);

  useEffect(() => {
    if (!currentSessionId) return;

    if (fromList) {
      setFromList(false);
      return;
    }
    compareData.map((item: any) => {
      if (String(item.session_id) === String(currentSessionId)) {
        setExperienceList(item.compareList);
      }
    });
  }, [compareData, currentSessionId]);

  useEffect(() => {
    const state = props.history.location.state;
    if (state) {
      if (state.session_id && state.session_id !== undefined) {
        const sessionId = state.session_id;
        setCurrentSessionId(sessionId);
        localStorage.setItem('session_id', sessionId);
      }
    }

  }, [props.history.location]);

  useEffect(() => {
    const request2 = {
      session_code: ids.find((x: any) => x.session_code === session_code),
      compare_session_codes: ids.filter((x: any) => cliped ? (x?.clip_id !== cliped?.clip_id) : (x?.clip_id !== cliped?.clip_id || x.session_code !== session_code)),
    }
    if(request2.session_code){
      dispatch(getCompareTabData(apolloClient.client, request2, (res: any) => {
        if (res) {
          // console.log('¬tags response¬', res)
          setCompareTabData(res);
        }
      }))
    }
  }, [experienceList])

  useEffect(() => {
    if (!specialProjectId) return;
    setProjectId(specialProjectId);
  }, [specialProjectId]);

  useEffect(() => {
    if (!specialProjectId) {
      const request1 = { projectOwnerId: Number(loginUserData.user_id) };
      dispatch(getProjects(apolloClient.client, request1));
    }
  }, [apolloClient.client, dispatch, loginUserData.user_id,]);

  useEffect(() => {
    const request = {
      user_id: loginUserData.user_id,
      page_no: 1,
      size: PAGINATION_PER_PAGE_ITEM * 5, //changed
      firstpage: true
    };
    dispatch(getExperiences(apolloClient.client, request, null));
    dispatch(initLiveAnalysisData());

  }, [apolloClient.client, dispatch, loginUserData.user_id,]);

  useEffect(() => {
    dispatch(getNorm2(apolloClient.client, { session_code: sessionCode }, (data: any) => {
      if (data) {
        const normData = {
          session_id: 999999,
          project_id: null,
          session_code: "industry_norm",
          session_title: "Industry Average",
          name: "Industry Average",
          session_description: "",
          immersion: data['norm_imm'],
          safety: data['norm_ps'],
          name_code: 'industry_average',
        };

        setImmersionNorm(normData.immersion);
        setSafetyNorm(normData.safety);
        // setNorm(normData);
      }
    }));
  }, [dispatch, sessionCode, props]);

  useEffect(() => {
    setExperienceList([])
  }, [cliped]);

  useEffect(() => {
    const state = props.history.location.state;
    if (state && state.data) {
      const data = state.data;
      if (data && data.length > 0) {
        setCompareData([...data,]);
        setSelected([...data]);
      }
    } else {
      if (analyzeClipData.length > 0 && !path) {
        const A: any = [];
        const B: any = [...analyzeClipData];
        const result = A.concat(B.filter((bo: any) => A.every((ao: any) => ao.session_id !== bo.session_id)));
        setCompareData(result);
      } else {
        if (experienceList.length === 0) {
          let curExperience = sessions.find((item: any) => {
            return (String(item.session_code) === String(sessionCode))
          });

          if (String(currentSessionId).includes('clip') && curExperience && curExperience.clips && curExperience.clips.length > 0) {
            const curClip = curExperience.clips.find((clip: any) => {
              return (String(clip.session_id) === String(currentSessionId));
            });
            if (curClip) curExperience = curClip;
          }

          if (curExperience) {
            setCompareData([curExperience]);
          }
        } else {
          // if (norm) {
          //   let A = [...experienceList];
          //   const B = [];
          //   if (!A) A = [];
          //   const result = A.concat(B.filter(bo => A.every(ao => ao.session_id !== bo.session_id)));
          //   setCompareData(result);
          // }
        }
      }
    }
  }, [sessions, currentSessionId, sessionCode, analyzeClipData]);

  const setCompareData = async (compareList: any) => {
    if (!currentSessionId || compareProcessing) return;
    setFromList(true);
    setCompareProcessing(true);
    const payload = { 'session_id': String(currentSessionId), compareList: compareList };
    const targetData = compareData.find((item: any) => String(item.session_id) === String(currentSessionId));

    if (targetData) {
      await dispatch(updateCompareData(payload));
    } else {
      await dispatch(addCompareData(payload));
    }

    setCompareProcessing(false);
    setExperienceList(compareList);
  };

  const onChangeSelected = (i: any) => {
    const array: any = [...selected];
    if ((selected.findIndex((item: any) => String(item.session_id) === String(i.session_id))) !== -1) {
      array.splice(array.findIndex((item: any) => String(item.session_id) === String(i.session_id)), 1);
      setSelected([...array]);
    } else {
      if (String(i.session_id).includes('clip-')) {
        const params = {
          tenant_id: loginUserData.customer_id,
          clip_id: i.clip_id,
          session_code: i.session_code
        };
        dispatch(onGetClipInfo(params, (res: any) => {
          if (res && res.data?.category_breakup) {
            const breakup = res.data?.category_breakup;
            const immersion_detail = {
              Captivated: breakup.immersion_breakup[0].category_percent,
              Absorbed: breakup.immersion_breakup[1].category_percent,
              Interested: breakup.immersion_breakup[2].category_percent,
              Indifferent: breakup.immersion_breakup[3].category_percent,
              "Tuned Out": breakup.immersion_breakup[4].category_percent,
            };

            const safety_detail = {
              Zen: breakup.safety_breakup[0].category_percent,
              'Very Safe': breakup.safety_breakup[1].category_percent,
              Safe: breakup.safety_breakup[2].category_percent,
              Unsafe: breakup.safety_breakup[3].category_percent,
              'Very Unsafe': breakup.safety_breakup[4].category_percent,
            };
            array.push({ ...i, immersion_detail, safety_detail });
            setSelected([...array]);
          }
        }));
      } else {
        array.push(i);
        setSelected([...array]);
      }
    }
  };

  const onCompare = () => {
    let A: any = [];
    const B: any = [...selected];

    if (analyzeClipData && analyzeClipData.length > 0) {
      if (analyzeClipData) {
        A = [analyzeClipData[0]];
      }
      const result = A.concat(B.filter((bo: any) => A.every((ao: any) => ao.session_id !== bo.session_id)));
      setCompareData(result);
      setDlgOpen(false);
    } else {
      let curExperience = sessions.find((item: any) => {
        return (String(item.session_code) === String(sessionCode))
      });

      if (String(currentSessionId).includes('clip') && curExperience && curExperience.clips && curExperience.clips.length > 0) {
        const curClip = curExperience.clips.find((clip: any) => {
          return (String(clip.session_id) === String(currentSessionId));
        });

        if (curClip) curExperience = curClip;
      }

      if (curExperience) {
          A = [curExperience];
      }

      const result = A.concat(B.filter((bo: any) => A.every((ao: any) => ao.session_id !== bo.session_id)));
      setCompareData(result);
      setDlgOpen(false);
    }
  };

  const clearAll = () => {
    let curExperience = sessions.find((item: any) => {
      return (String(item.session_code) === String(sessionCode))
    });

    if (String(currentSessionId).includes('clip') && curExperience && curExperience.clips && curExperience.clips.length > 0) {
      const curClip = curExperience.clips.find((clip: any) => {
        return (String(clip.session_id) === String(currentSessionId));
      });

      if (curClip) curExperience = curClip;
    }

    if (curExperience) {
      setCompareData([curExperience]);
    }
    setSelected([]);
    setDlgOpen(false);
  };

  const onFilterDirection = (e: any) => {
    let result = 'status';
    let sort_column = '';

    if (e === 1) { result = 'name'; sort_column = 'session_title_key' }
    if (e === 2) { result = 'id' }
    if (e === 3) { result = 'type' }
    if (e === 4) { result = 'survey' }
    if (e === 5) { result = 'clips' }
    if (e === 6) { result = 'imm'; sort_column = "immersion_index" }
    if (e === 7) { result = 'sfty'; sort_column = "safety_index" }
    if (e === 8) { result = 'status'; sort_column = "session_status" }
    if (e === 9) { result = 'start'; sort_column = "sort_start" }
    if (e === 10) { result = 'end'; sort_column = "sort_end" }
    if (e === 11) { result = 'participants' }

    if (e === 1 || e === 6 || e === 7 || e === 8 || e === 9 || e === 10) {
      dispatch(setLoading(true));
      setSortColumn(sort_column);

      if (searchKey && searchKey !== 'empty') {
        const req = {
          sort_direction: filterDirection ? "asc" : "desc",
          sort_column: sort_column,
          keyword: searchText,
          user_id: searchUsers,
          page_no: 1,
          size: PAGINATION_PER_PAGE_ITEM * page,
          clip_page_no: 1,
          clip_page_size: PAGINATION_PER_PAGE_ITEM * page,
          identifier: 'session'
        };
        setSortDirection(filterDirection ? "asc" : "desc");
        dispatch(searchExperience(apolloClient.client, req))

      } else if (projectId !== -1 && projectId !== -2) {
        const req = {
          sort_direction: filterDirection ? "asc" : "desc",
          sort_column: sort_column,
          project_id: projectId
        };
        setSortDirection(filterDirection ? "asc" : "desc");
        dispatch(getProjectExperiences(apolloClient.client, req, null));
      } else {
        const req = {
          user_id: loginUserData.user_id,
          page_no: 1,
          size: PAGINATION_PER_PAGE_ITEM * page,
          firstpage: true,
          sort_direction: filterDirection ? "asc" : "desc",
          sort_column: sort_column
        };
        setSortDirection(filterDirection ? "asc" : "desc");
        dispatch(getExperiences(apolloClient.client, req, null));
      }
    }

    setFilter(result);
    setFilterDirection(!filterDirection)
  };

  // const capitalize = (input: any) => {
  //   const words = input.split(' ');
  //   const CapitalizedWords: any = [];
  //   words.forEach((element: any) => {
  //     CapitalizedWords.push(element[0].toUpperCase() + element.slice(1, element.length));
  //   });
  //   return CapitalizedWords.join(' ');
  // };

  const onCompareFilterDirection = (e: any) => {
    // let result = e;
    // if (e !== 'immersion' && e !== 'safety') {
    //   result = capitalize(e);
    // }
    dispatch(updateTableSort(e))
    if (e === currentFilterArray.compareFilter) {
      setcurrentFilterArray({ compareFilter: e, filterDirection: !currentFilterArray.filterDirection });
    } else {
      setcurrentFilterArray({ compareFilter: e, filterDirection: true });
    }
  };

  if (!sessionCode) {
    return <Redirect to='/creator/dashboard' />
  }

  const onAddExperiences = () => {
    setDlgOpen(true);
  };

  const closeDlg = () => {
    setDlgOpen(false);
  };

  const clearSearch = () => {
    setSearchText("");
    setSelectedCompare([]);
    setUserDropdown(false);
    dispatch(updateSearchText(''));
    dispatch(updateSearchUsers([]));
    dispatch(updatesearchfilters('clear'));
    dispatch(updateSearchKey(''));
    dispatch(getCreatorList(null));
  };

  useEffect(() => {
    if (searchfilters && searchfilters === 'clear') {
      setSortDirection("");
      setSortColumn("");
      setFilterDirection(false);
      setFilter("");
      dispatch(updatesearchfilters(''));
    }
  }, [searchfilters]);

  useEffect(() => {
    if (creatorList && creatorList.length) {
      setUserDropdown(true);
      setCreators(creatorList);
    }
  }, [creatorList]);

  const checkformultiUsers = () => {
    dispatch(getCreatorsList(apolloClient.client));
    if (Creators && Creators.length > 1) {
      setUserDropdown(true);
    }
  };

  const onSearchExp = (e: any) => {
    setSearchText(e.target.value);
    dispatch(updatesearchfilters('clear'));
    const searchText = e.target.value.trim();
    if (searchText && searchText.length >= 3 && Creators.length <= 1) { // there are inserted texts
      const req = {
        keyword: searchText,
        user_id: [],
        page_no: 1,
        size: PAGINATION_PER_PAGE_ITEM * page,
        clip_page_no: 1,
        clip_page_size: PAGINATION_PER_PAGE_ITEM * page,
        identifier: 'session'
      };
      dispatch(searchExperience(apolloClient.client, req));
      dispatch(updateSearchText(searchText));
      setUserDropdown(false);
    } else { // empty value in the search box
      if (e.target.value.trim().length <= 0 && selectedCompare.length <= 0) {
        dispatch(updateSearchKey(null));
      }
    }
  };
  const onCancel = () => {
    clearSearch();
  };

  const applySearch = () => { // apply search with user selection
    const req = {
      keyword: searchText,
      user_id: checked,
      page_no: 1,
      size: PAGINATION_PER_PAGE_ITEM * page,
      clip_page_no: 1,
      clip_page_size: PAGINATION_PER_PAGE_ITEM * page,
      identifier: 'session'
    };
    dispatch(searchExperience(apolloClient.client, req));
    dispatch(updateSearchText(searchText));
    dispatch(updateSearchUsers(checked));
    dispatch(updatesearchfilters('clear'));
    setUserDropdown(false);
  };

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13 && ((searchText && searchText.trim().length >= 3) || selectedCompare.length > 0 || (searchKey))) {
      applySearch();
    }
  };

  const nextPageData = () => {
    if (page < Math.ceil(totalExperience / PAGINATION_PER_PAGE_ITEM)) {
      const request = {
        user_id: loginUserData.user_id,
        page_no: page + 1,
        size: PAGINATION_PER_PAGE_ITEM,
        sort_direction: sortDirection,
        sort_column: sortColumn
      };
      dispatch(getExperiences(apolloClient.client, request, null));
      dispatch(updatePage(page + 1))
    }
    if (page < Math.ceil(totalReelExperience / PAGINATION_PER_PAGE_ITEM)) {
      const request = {
        user_id: loginUserData.user_id,
        page_no: page + 1,
        size: PAGINATION_PER_PAGE_ITEM,
        sort_direction: sortDirection,
        sort_column: sortColumn
      };
      dispatch(getListExperiencesReels(apolloClient.client, request));
      dispatch(updatePage(page + 1))
    }
  };

  const handleSelectUser = (e: any, value: any) => {
    e.preventDefault();

    const checkedvalues: any = [];
    if (value && value.length) {
      value.map((val: any) => {
        checkedvalues.push(parseFloat(val.user_id));
      })
    }

    setchecked(checkedvalues);
    setSelectedCompare(value);
  };

  useEffect(() => {
    if (searchText.length <= 0 && selectedCompare.length <= 0) {
      dispatch(updateSearchKey(null));
    }
  }, [searchKey]);

  const goto = () => {
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    let url = '/creator/experience-builder';
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['builder'])) {
        url = '/subscriber/creator/experience-builder'
      }
    }
    return url;
  };

  return (

    <div className={classes.root} style={{ paddingTop: 37, background: '#f0f0f0' }} id='compare'>
      <Helmet title="Compare" />
      <BackDropAnalyzeLoading loading={is_loading || tagLoading || !compareData} />

      {!isMobileDevice && !is_loading && <div className={classes.headerPanel}>
        <CompareHeader
          compareMode={compareMode}
          onCompareModeChange={(mode: number) => setCompareMode(mode)}
        />
      </div>}

      {!isMobileDevice && <div className={classes.container}>

        {!is_loading && listLoading
          ? <Loading /> : (
            <div>
              {compareMode === 2 &&

                <CompareBar
                  sessions={
                    _.sortBy(UtilService.filterByProject(experienceList, projectId), 'start')
                  }
                  immersionNorm={immersionNorm}
                  safetyNorm={safetyNorm}
                  category={curCategory}
                />
              }

              <CompareTable
                experienceList={experienceList}
                projectId={projectId}
                className={classes.tableContainer}
                selected={selected}
                category={curCategory}
                onChangeSelected={(i: any) => onChangeSelected(i)}
                onClickFilter={(e: any) => onCompareFilterDirection(e)}
                onCategoryChanged={(e: any) => setCurCategory(e)}
                currentFilterArray={currentFilterArray}
                compareTabData={compareTabData}
                setTagLoading={setTagLoading}
              />
            </div>
          )}
        {!isMobileDevice && !(!listLoading && projectId === -1 && (!sessions || sessions.length === 0)) &&
          <div className={classes.bottomContainer}>
            <span className={classes.text}>Need to add some more Experiences or Clips to compare?</span>
            <Button
              color="secondary"
              className={classes.addBtn}
              style={{ marginLeft: 21 }}
              onClick={() => onAddExperiences()}
            >
              Add Experiences
            </Button>
          </div>
        }
        {!listLoading && projectId === -1 && (!sessions || sessions.length === 0) &&
          <div className={classes.empty}>
            <img src={'/assets/icons/creatordashboard/empty_screen.svg'} alt={'img'} />
            <p className={classes.title}>
              There are no items…
              <Link to={goto} style={{ textDecoration: 'none' }}>
                <span className={classes.hover}>let’s create.</span>
              </Link>
            </p>
          </div>
        }

      </div>
      }

      {
        isMobileDevice && <AnalyzeMobileSection />
      }
      <Dialog
        className={classes.dlgRoot}
        PaperProps={{
          style: {
            backgroundColor: '#F0F0F0'
          },
        }}
        fullScreen={true}
        aria-labelledby="simple-dialog-title"
        onClose={() => closeDlg()}
        open={dlgOpen}>
        <DialogTitle id="simple-dialog-title">
          <IconButton aria-label="close" className={classes.closeButton} onClick={() => closeDlg()}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dlgContent}>
          <div className={classes.dlgTitle}>Add More Experiences to Compare</div>

          <div className={classes.searchContainer}>
            <TextField
              className="inputRounded"
              size="small"
              variant="outlined"
              style={{ color: '#697683' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SvgIcon
                      fontSize="small"
                      color="action"
                    >
                      <SearchIcon />
                    </SvgIcon>
                  </InputAdornment>
                ),
                endAdornment: <InputAdornment position="end">
                  {searchText && <img
                    src={'/assets/icons/creatordashboard/remove.svg'}
                    alt={'icon'}
                    className={classes.icon}
                    onClick={() => clearSearch()}
                  />}
                </InputAdornment>
              }}

              value={searchText}
              onChange={(e) => onSearchExp(e)}
              onFocus={() => checkformultiUsers()}
            />
          </div>
          {
            (isUserDropdown && Creators.length > 1) &&
            <>
              <div className="creatorlistBackground" onClick={() => setUserDropdown(false)}></div>
              <div className="Creators_list">
                <Paper elevation={10} className="creator_list_paper" variant="outlined" >
                  <Autocomplete
                    multiple
                    id="creator-users-autocomplete"
                    options={Creators}
                    value={selectedCompare}
                    disableCloseOnSelect
                    onChange={(e: any, selectedCompare: any) => handleSelectUser(e, selectedCompare)}
                    getOptionLabel={(option: any) => (option.first_name && option.last_name) ? option.first_name + " " + option.last_name : option.username}
                    renderOption={(option: any) => (
                      <React.Fragment>
                        <ListItem key={option.user_id} role={undefined} dense button className="creatorlistItem">
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={checked.indexOf(parseFloat(option.user_id)) !== -1}
                          />
                          <ListItemText className="creatorListText" primary={(option.first_name && option.last_name) && option.first_name + " " + option.last_name} secondary={option.username} />
                        </ListItem>
                      </React.Fragment>
                    )}
                    style={{ width: '100%', fontSize: "12px" }}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" label="Select Creators" placeholder="" />
                    )}
                  />
                  <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
                    <Button onClick={onCancel} variant="contained" size='small' className={classes.modalBtn}>
                      Cancel
                    </Button>
                    <Button onClick={applySearch}
                      disabled={((searchText && searchText.trim().length >= 3) || selectedCompare.length > 0 || (searchKey)) ? false : true}
                      variant="contained" color='primary' size='small' className={classes.modalBtn}>
                      Apply
                    </Button>
                  </Box>
                </Paper>
              </div>
            </>
          }

          {!searchKey &&
            <>
              {width > 1025 && <Projects
                onSelectProject={(e: number) => setProjectId(e)}
                projectId={projectId}
              />}
              {!is_loading && listLoading
                ? <Loading /> : (
                  <div className={clsx(classes.table, selected.length > 0 && classes.selected)}>
                    <CreatorTable
                      sessions={sessions}
                      selected={selected}
                      filter={filter}
                      disableNavigation={true}
                      onChangeSelected={(i: any) => onChangeSelected(i)}
                      onClickFilter={(e: any) => onFilterDirection(e)}
                      filterDirection={filterDirection}
                    />
                    {sessions && sessions.length > 0 && Math.ceil(totalExperience / PAGINATION_PER_PAGE_ITEM) !== page && projectId === -1 && sessions.length !== totalExperience && (
                      <div className={classes.loadMoreDiv}>
                        <Button className={classes.loadMoreBtn} onClick={nextPageData}>
                          Load more...
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              {!listLoading && projectId === -1 && (!sessions || sessions.length === 0) && (
                <div className={classes.empty}>
                  <img src={'/assets/icons/creatordashboard/empty_screen.svg'} alt={'img'} />
                  <p className={classes.title}>
                    There are no items…
                    <Link to={goto} style={{ textDecoration: 'none' }}>
                      <span className={classes.hover}>let’s create.</span>
                    </Link>
                  </p>
                </div>
              )}
            </>
          }

          {searchKey && searchKey !== 'empty' && (
            <CreatorResult
              sessions={searchKey.sessions}
              selected={selected}
              filter={filter}
              disableNavigation={true}
              onChangeSelected={(i: any) => onChangeSelected(i)}
              onClickFilter={(e: any) => onFilterDirection(e)}
              filterDirection={filterDirection}
            />
          )}

          {
            (UtilService.filterByProject(sessions, projectId)).length === 0 && projectId !== -1 &&
            <>
              <Projects
                onSelectProject={(e: number) => setProjectId(e)}
                projectId={projectId}
              />
              <div className={classes.empty}>
                <img src={'/assets/icons/creatordashboard/empty_screen.svg'} alt={'img'} />
                <p className={classes.title}>
                  There are no items in this project…
                  <span className={classes.hover} onClick={() => setProjectId(-1)}>let’s find some.</span>
                </p>
              </div>
            </>
          }

        </DialogContent>

        {selected.length > 0 && (
          <CreatorTray
            sessions={UtilService.filterByProject(sessions, projectId)}
            hideAddToProject={true}
            selected={selected}
            clearAll={clearAll}
            onRemove={(e: any) => onChangeSelected(e)}
            onCompare={() => onCompare()}
          />
        )}

      </Dialog>

    </div>
  )
}